// Webpack Imports
import * as bootstrap from 'bootstrap';
// import Swiper JS
import Swiper from 'swiper/bundle';

import Gallery from './gallery.js'
import balanceText from './balancetext.min.js'

const swiper = new Swiper('.swiper-project', {
	// Optional parameters
	// direction: 'horizontal',
	//loop: true,
	watchOverflow: true,
	speed: 800,
	autoplay: {
		delay: 5000,
	  },

	// If we need pagination
	pagination: {
	  el: '.swiper-pagination',
	  clickable: true,
	},
  
	// Navigation arrows
	navigation: {
	  nextEl: '.swiper-button-next',
	  prevEl: '.swiper-button-prev',
	},
  });


  const press = new Swiper('.swiper-press', {
	// Optional parameters
	// direction: 'horizontal',
	slidesPerView: 'auto',
  	spaceBetween: 30,
	autoHeight: true,
	//loop: true,
	//loopedSlides: 5,

	// If we need pagination
	pagination: {
	  el: '.swiper-pagination',
	  clickable: true,
	},
  
	// Navigation arrows
	navigation: {
	  nextEl: '.swiper-button-next',
	  prevEl: '.swiper-button-prev',
	},
  });

( function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	var myModal = document.getElementById('search')
	var myField = document.getElementById('search-field')
	var mModal = new bootstrap.Collapse(myModal, {
		toggle: false
	  })
	myModal.addEventListener('shown.bs.collapse', function () {
		myField.focus()
	  })

	// myField.addEventListener("blur", function () {
	// 	console.log('blur');
	// 	mModal.Collapse(myModal, {
	// 		toggle: true
	// 	  })
	//   });




	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );
} )();